import React from 'react';
import { Outlet } from 'react-router';

import { CheckAuth } from '../checkAuth/checkAuth.component';

export const CheckAuthLayout: React.FC = (): JSX.Element => (
  <CheckAuth>
    <Outlet />
  </CheckAuth>
);
